module.exports = __webpack_public_path__ + "static/media/primairePhoto.4e4fe23b.png";